// ref: update quota in coupon and set the coupon to null in the transaction
// https://gitlab.com/web-apps-dietela/backend/-/merge_requests/235

export const reqResetCoupon = async(axios, { transactionId }) => {
  if (!transactionId) throw new Error('transactionId is required')
  return axios.post(`/v1/clients/coupons/${transactionId}`)
}